import { MenuOutlined } from '@ant-design/icons';
import { useAtomValue } from 'jotai';
import React, { useState } from 'react';
import { focusModeAtom, headerTitleAtom } from '~/atoms';

import './BackdropHeader.scss';
import BurgerHeader from './BurgerHeader';

export default function BackdropHeader({ children }) {
  const [backdropHeadOpen, setBackdropHeadOpen] = useState(false);
  const focusMode = useAtomValue(focusModeAtom);
  const title = useAtomValue(headerTitleAtom);

  return (
    <>
      <div className={`backdrop${focusMode ? ' focused' : ''}`}>
        {!focusMode && (
          <div className='backdrop-head'>
            <div className='backdrop-head-activator'>
              <MenuOutlined onClick={() => setBackdropHeadOpen(true)} />
              {title && <span className='backdrop-head-title'>{title}</span>}
            </div>
            <div className='backdrop-head-content'>
              <BurgerHeader open={backdropHeadOpen} setOpen={setBackdropHeadOpen} />
            </div>
          </div>
        )}

        <div className='backdrop-content'>{children}</div>
      </div>
    </>
  );
}
